import React from "react";
import { RedactionForm } from "../../@components/AiToolkit/Redaction/RedactionForm";

export function Redaction() {
  return <RedactionForm />;
}
